<template>
  <div>
    <empty-state
      v-if="loading || !tables || tables.length === 0"
      :loading="loading"
      :title="loading ? $t('loading') : $t('no_data_available')"
      :subtitle="!loading ? $t('no_restaurants_found') : ''"
      icon="mdi-silverware"
    />
    <v-card v-else flat>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="tables"
          :search="searchQuery"
          class="striped-table ordera-box-shadow"
          :loading="loading"
        >
          <template
            v-for="header in headers"
            v-slot:[`header.${header.value}`]="{ header }"
          >
            {{ $t(header.text) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EmptyState from "@/components/global/EmptyState.vue";

export default {
  name: "RestaurantsTab",
  components: {
    EmptyState,
  },
  props: {
    tables: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: "",
    },
    selectedStatus: {
      type: Object,
      default: () => ({ id: 0, name: "all" }),
    },
    selectedDeliveryType: {
      type: Object,
      default: () => ({ id: 3, name: "all" }),
    },
  },
  data() {
    return {
      headers: [
        { text: "num", value: "num", sortable: false },
        { text: "table", value: "desk_name", sortable: true },
        { text: "name_lastname", value: "name", sortable: true },
        { text: "ordered", value: "orders", sortable: false },
        { text: "price1", value: "price", sortable: true },
        { text: "actions", value: "action", sortable: false },
      ],
    };
  },
};
</script>
